import styles from "../index.css";
import fonts from "../../../../iconfonts.css";
import React from "react";


const OnHoverDescription = (props)=>{
    const container = props.container;
    return(
        <div className={styles.description}>
            <h3>Сформувати сценарій</h3>
            {props.container ?
                <div>
                    <div className={styles.cultureIcon}><i className={fonts[container.culture]}/></div>
                    <h3>{container.name}</h3>
                    <div className={styles.groupData}>
                        Культура: {container.culture} <br/>
                        {(container.type === 'silo' || container.type === 'bunker' || container.type === 'hopper' || container.type === 'output') && (<div>Загальна вага: {container.amount.toFixed(1)} тон<br/></div>)}
                        Смітність: {Math.round(container.wasteLevel * 10) / 10}%<br/>
                        Вологість: {Math.round(container.moistureLevel * 10) / 10}%<br/>
                        {container.errorStatus ? "Помилка: "+ container.errorStatus : ''}
                    </div>
                </div>
                :
                null
            }
        </div>
    )
};

export default OnHoverDescription


// WEBPACK FOOTER //
// ./src/shared/components/PathPopup/onHoverDescription/index.js